<template>
    <div class="ngdialog-content">
        <dialog-header>
            <h4>{{ $t('users_admin.permissions') }}</h4>
        </dialog-header>

        <form name="permissionsForm" novalidate @submit.prevent="submitHandler" class="form">
            <div class="ngdialog__body">
                <fieldset class="form__group form__group--columns">
                    <div class="row form__row">
                        <label class="form__label">{{ $t('fields.organization_parameter') }}</label>
                        <select class="form__field" v-model="formData.parameter">
                            <option :value="null"></option>
                            <option
                                value="information"
                                :label="$t('organizations.parameter_informationlayer')"
                                >{{ $t('organizations.parameter_informationlayer') }}</option
                            >
                            <option
                                value="operator"
                                :label="$t('organizations.parameter_operatorlayer')"
                                >{{ $t('organizations.parameter_operatorlayer') }}</option
                            >
                            <option
                                value="service"
                                :label="$t('organizations.parameter_servicelayer')"
                                >{{ $t('organizations.parameter_servicelayer') }}</option
                            >
                            <option value="oem" :label="$t('organizations.parameter_oemlayer')">{{
                                $t('organizations.parameter_oemlayer')
                            }}</option>
                        </select>
                    </div>
                    <div class="row form__row">
                        <label class="form__label">{{
                            $t('fields.organization_label_admin')
                        }}</label>
                        <select class="form__field" v-model="formData.label_admin">
                            <option :value="null"></option>
                            <option :value="true" :label="$t('common.yes')">{{
                                $t('common.yes')
                            }}</option>
                            <option :value="false" :label="$t('common.no')">{{
                                $t('common.no')
                            }}</option>
                        </select>
                    </div>
                    <div class="row form__row">
                        <label class="form__label">{{
                            $t('fields.organization_label_assign')
                        }}</label>
                        <select class="form__field" v-model="formData.label_assign">
                            <option :value="null"></option>
                            <option :value="true" :label="$t('common.yes')">{{
                                $t('common.yes')
                            }}</option>
                            <option :value="false" :label="$t('common.no')">{{
                                $t('common.no')
                            }}</option>
                        </select>
                    </div>
                    <div class="row form__row">
                        <label class="form__label">{{
                            $t('fields.organization_label_notification_admin')
                        }}</label>
                        <select class="form__field" v-model="formData.notification_admin">
                            <option :value="null"></option>
                            <option :value="true" :label="$t('common.yes')">{{
                                $t('common.yes')
                            }}</option>
                            <option :value="false" :label="$t('common.no')">{{
                                $t('common.no')
                            }}</option>
                        </select>
                    </div>
                    <div class="row form__row">
                        <label class="form__label">{{
                            $t('fields.organization_label_system_activate')
                        }}</label>
                        <select class="form__field" v-model="formData.system_activate">
                            <option :value="null"></option>
                            <option :value="true" :label="$t('common.yes')">{{
                                $t('common.yes')
                            }}</option>
                            <option :value="false" :label="$t('common.no')">{{
                                $t('common.no')
                            }}</option>
                        </select>
                    </div>
                    <div class="row form__row">
                        <label class="form__label">{{
                            $t('fields.organization_label_system_register')
                        }}</label>
                        <select class="form__field" v-model="formData.system_register">
                            <option :value="null"></option>
                            <option :value="true" :label="$t('common.yes')">{{
                                $t('common.yes')
                            }}</option>
                            <option :value="false" :label="$t('common.no')">{{
                                $t('common.no')
                            }}</option>
                        </select>
                    </div>
                    <div class="row form__row">
                        <label class="form__label">{{
                            $t('fields.organization_label_webserver_settings')
                        }}</label>
                        <select class="form__field" v-model="formData.webserver_settings">
                            <option :value="null"></option>
                            <option :value="true" :label="$t('common.yes')">{{
                                $t('common.yes')
                            }}</option>
                            <option :value="false" :label="$t('common.no')">{{
                                $t('common.no')
                            }}</option>
                        </select>
                    </div>
                    <div class="row form__row">
                        <label class="form__label">{{
                            $t('fields.organization_label_webserver_update')
                        }}</label>
                        <select class="form__field" v-model="formData.webserver_update">
                            <option :value="null"></option>
                            <option :value="true" :label="$t('common.yes')">{{
                                $t('common.yes')
                            }}</option>
                            <option :value="false" :label="$t('common.no')">{{
                                $t('common.no')
                            }}</option>
                        </select>
                    </div>
                    <div class="row form__row">
                        <label class="form__label">{{
                            $t('fields.organization_label_webserver_recorder')
                        }}</label>
                        <select class="form__field" v-model="formData.webserver_recorder">
                            <option :value="null"></option>
                            <option :value="true" :label="$t('common.yes')">{{
                                $t('common.yes')
                            }}</option>
                            <option :value="false" :label="$t('common.no')">{{
                                $t('common.no')
                            }}</option>
                        </select>
                    </div>
                    <div class="row form__row">
                        <label class="form__label">{{
                            $t('fields.organization_label_grafana_access')
                        }}</label>
                        <select class="form__field" v-model="formData.grafana_access">
                            <option :value="null"></option>
                            <option :value="true" :label="$t('common.yes')">{{
                                $t('common.yes')
                            }}</option>
                            <option :value="false" :label="$t('common.no')">{{
                                $t('common.no')
                            }}</option>
                        </select>
                    </div>
                </fieldset>
            </div>

            <dialog-buttons :submit-text="$t('buttons.save_changes')" :disabled="loading" />
        </form>
    </div>
</template>

<script>
import * as api from '@/api';
import DialogHeader from '@/components/DialogHeader';
import DialogButtons from '@/components/DialogButtons';

export default {
    components: {
        DialogHeader,
        DialogButtons,
    },
    props: {
        user: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            loading: false,
            formData: {
                parameter: 0,
                label_admin: 0,
                label_assign: 0,
                notification_admin: 0,
                system_activate: 0,
                system_register: 0,
                webserver_settings: 0,
                webserver_update: 0,
                webserver_recorder: 0,
                grafana_access: 0,
            },
        };
    },
    mounted() {
        this.getUser();
    },
    methods: {
        prepareData(permissions) {
            for (const key in this.formData) {
                let value = permissions[key];
                this.formData[key] = value;
            }
        },
        submitHandler() {
            this.savePermissions();
        },
        async getUser() {
            try {
                const response = await api.users.get(this.user.id);
                if (response && response.data) {
                    this.prepareData(response.data.permissions);
                }
            } catch (error) {
                console.error(error);
            }
        },
        async savePermissions() {
            const data = {
                parameter: this.formData.parameter,
                label_admin: this.formData.label_admin,
                label_assign: this.formData.label_assign,
                notification_admin: this.formData.notification_admin,
                system_activate: this.formData.system_activate,
                system_register: this.formData.system_register,
                webserver_settings: this.formData.webserver_settings,
                webserver_update: this.formData.webserver_update,
                webserver_recorder: this.formData.webserver_recorder,
                grafana_access: this.formData.grafana_access,
            };

            try {
                await api.users.updatePermissions(this.user.id, data);
                this.loading = false;
                this.$emit('close');
            } catch (error) {
                console.error(error);
                this.loading = false;
                this.$notify({
                    type: 'error',
                    text: this.$t('errors.organization_permission_update_error'),
                });
            }
        },
    },
};
</script>
